import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClaimsService } from 'src/app/core/services/claims.service';
import {
  CommunicationService,
  ThreadWithMessagesAndClaimCase,
} from 'src/app/core/services/communication.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-communications',
  templateUrl: './communications.component.html',
  styleUrls: ['./communications.component.scss'],
})
export class CommunicationsComponent implements OnInit {
  claimId: string | null = null;
  threads!: { data: ThreadWithMessagesAndClaimCase[]; count: number | null };
  claim: any;

  loading: boolean = true;
  loadingMore: boolean = false;
  currentPage: number = 0;
  hasMoreMessages: boolean = true;
  pageSize: number = 10;

  constructor(
    private cs: CommunicationService,
    private cls: ClaimsService,
    private us: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    console.log('Communications Component =< Hello again');
    this.claimId = this.activatedRoute.snapshot.paramMap.get('claim');

    if (this.claimId) {
      this.claim = await this.cls.getClaimWithCase(this.claimId);
    }

    await this.getData();
  }

  async getData() {
    try {
      this.loading = true;
      this.currentPage = 0;
      this.hasMoreMessages = true;

      if (!this.claimId) {
        const user = await this.us.getCurrentUser();
        const claims = await this.cls.getAllClaimsForUserId(user!.id!);
        const claimsId: string[] = claims ? claims.map((c) => c.id!) : [];

        console.log('CLAIMS', claimsId);

        const threads = await this.cs.userRelatedCommunications(
          claimsId,
          user!.id!,
          { page: this.currentPage, limit: this.pageSize }
        );

        console.log('THREADS', threads);
        this.threads = threads;
        this.hasMoreMessages = threads.count
          ? threads.count > this.pageSize
          : false;
      } else {
        const result =
          await this.cs.listCommunicationsWithMessagesAndCaseForClaim(
            this.claimId!,
            { page: this.currentPage, limit: this.pageSize }
          );

        this.threads = {
          data: result.data,
          count: result.count,
        };
        this.hasMoreMessages = result.count
          ? result.count > this.pageSize
          : result.data.length === this.pageSize;
      }
    } catch (error) {
      console.error(error);
      this.router.navigate(['client']);
    } finally {
      this.loading = false;
    }
  }

  async loadMoreMessages() {
    if (this.loadingMore || !this.hasMoreMessages) return;

    try {
      this.loadingMore = true;
      this.currentPage++;

      if (!this.claimId) {
        const user = await this.us.getCurrentUser();
        const claims = await this.cls.getAllClaimsForUserId(user!.id!);
        const claimsId: string[] = claims ? claims.map((c) => c.id!) : [];

        const newThreads = await this.cs.userRelatedCommunications(
          claimsId,
          user!.id!,
          { page: this.currentPage, limit: this.pageSize }
        );

        this.threads.data = [...this.threads.data, ...newThreads.data];
        this.threads.count = newThreads.count;

        this.hasMoreMessages = newThreads.count
          ? (this.currentPage + 1) * this.pageSize < newThreads.count
          : newThreads.data.length === this.pageSize;
      } else {
        const newResult =
          await this.cs.listCommunicationsWithMessagesAndCaseForClaim(
            this.claimId!,
            { page: this.currentPage, limit: this.pageSize }
          );

        this.threads.data = [...this.threads.data, ...newResult.data];
        this.threads.count = newResult.count;

        this.hasMoreMessages = newResult.count
          ? (this.currentPage + 1) * this.pageSize < newResult.count
          : newResult.data.length === this.pageSize;
      }
    } catch (error) {
      console.error('Erro ao carregar mais mensagens:', error);
      this.currentPage--;
    } finally {
      this.loadingMore = false;
    }
  }

  goToNewMessage() {
    console.log('Go to new message! =)');
    this.router.navigate(['client/messages/new/new']);
  }

  goToMessage() {
    this.router.navigate(['/client/messages']);
  }

  goToMessageWithClaim() {
    this.router.navigate(['/client/messages', this.claimId ?? '']);
  }
}
